(function () {
  'use strict';

  if (window.starlightVariantGalleryInitialized) return;
  window.starlightVariantGalleryInitialized = true;

  var dataEl = document.getElementById('variant-gallery-data');
  if (!dataEl) return;

  var variants;

  try {
    variants = JSON.parse(dataEl.getAttribute('data-variants') || '[]');
  } catch (error) {
    console.error('Variant gallery data could not be read.', error);
    return;
  }

  if (!Array.isArray(variants) || variants.length === 0) return;

  var gallery = dataEl.closest('media-gallery');
  if (!gallery) return;

  function getMediaId(value) {
    if (!value) return '';

    var parts = String(value).split('-');
    return parts[parts.length - 1];
  }

  function getRelatedMediaIds(variant) {
    if (!variant || !Array.isArray(variant.options)) return [];

    var selectedSize = variant.options[0];
    var selectedChairs = variant.options[1];

    return variants
      .filter(function (item) {
        return (
          Array.isArray(item.options) &&
          item.options[0] === selectedSize &&
          item.options[1] === selectedChairs
        );
      })
      .map(function (item) {
        return item.featured_image
          ? String(item.featured_image.id)
          : '';
      })
      .filter(Boolean);
  }

  function filterGallery(variant) {
    var relatedMediaIds = getRelatedMediaIds(variant);

    if (relatedMediaIds.length === 0) return;

    gallery
      .querySelectorAll('.product__media-item[data-media-id]')
      .forEach(function (item) {
        var mediaId = getMediaId(item.getAttribute('data-media-id'));
        item.hidden = !relatedMediaIds.includes(mediaId);
      });

    gallery
      .querySelectorAll('.thumbnail-list__item[data-target]')
      .forEach(function (thumbnail) {
        var mediaId = getMediaId(thumbnail.getAttribute('data-target'));
        thumbnail.hidden = !relatedMediaIds.includes(mediaId);
      });
  }

  function findVariantById(variantId) {
    if (!variantId) return null;

    return variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    });
  }

  function getSelectedVariant() {
    var productInfo = gallery.closest('product-info');
    var variantInput = productInfo
      ? productInfo.querySelector('form[action*="/cart/add"] input[name="id"]')
      : null;

    var selectedVariant = variantInput
      ? findVariantById(variantInput.value)
      : null;

    if (selectedVariant) return selectedVariant;

    var urlVariantId = new URL(window.location.href).searchParams.get('variant');
    return findVariantById(urlVariantId) || variants[0];
  }

  document.addEventListener('variant:change', function (event) {
    if (event.detail && event.detail.variant) {
      filterGallery(event.detail.variant);
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target.closest('variant-selects, variant-radios')) return;

    window.setTimeout(function () {
      filterGallery(getSelectedVariant());
    }, 0);
  });

  filterGallery(getSelectedVariant());
})();
